/**
 * Initialize Sticky player
 *
 * @param {*} players player list in page = { playerList, playerConfigList }
 */
import { VIDEO_PLAYER_OBSERVER_OPTIONS, VIDEO_PLAYER_OBSERVER_OPTIONS_MOBILE } from '../video-player/constants';
import { isMobile, isWidthDeviceMobile, isWidthDeviceMobileTablet } from '../../utils/device-utils';
import { isLandscape } from '../../utils/mediaquery-utils';
import { COMMON_STATE_KEYS } from '../../global-store/subjects/common/initial-state';
import { getCommonStorePartial } from '../../global-store/subjects/common';
import { heroDisclaimer } from '../hero-disclaimer/hero-disclaimer';

import {
  disableStickyElement,
  elementToObserve,
  enableStickyElement,
  getMobileTreshold,
  isLMPArticle,
} from './helpers';
import { initVideoPlayerListeners } from './video-player-listeners';
import { stickyHeroPlayerState } from './state';
import { $heroStickyPlayerWrapper, $player } from './constants';

export const stickyHeroPlayerDisclaimer = heroDisclaimer({
  elementToAppendTo: $heroStickyPlayerWrapper,
});

export const init = (players) => {
  if (!$player) {
    return;
  }
  initVideoPlayerListeners(players);
  const observerOptions = isWidthDeviceMobile() ? VIDEO_PLAYER_OBSERVER_OPTIONS_MOBILE : VIDEO_PLAYER_OBSERVER_OPTIONS;

  const playerContainerObserver = new IntersectionObserver((entries) => {
    const elementThresholdDesktop = isLMPArticle ? 0.5 : 0.3;
    const elementThresholdMobile = getMobileTreshold();
    const elementThreshold = isMobile() ? elementThresholdDesktop : elementThresholdMobile;
    entries.forEach((elem) => {
      if ((isMobile() && isLandscape()) || stickyHeroPlayerState.getState('hasUserRejectedSticky')) {
        return;
      }

      if (elem.intersectionRatio < elementThreshold) {
        enableStickyElement();
        stickyHeroPlayerState.setState('isTresholdPassed', true);
      } else if (elem.intersectionRatio >= elementThreshold) {
        disableStickyElement();
        stickyHeroPlayerState.setState('isTresholdPassed', false);
      }
    });
  }, observerOptions);

  playerContainerObserver.observe(elementToObserve());

  // Toggle depending on the HP injected
  const isInjectedHPStore = getCommonStorePartial(COMMON_STATE_KEYS.IS_INJECTED_HP);
  isInjectedHPStore.subscribe((isInjectedHP) => {
    if (isInjectedHP) {
      stickyHeroPlayerState.setState('hasUserRejectedSticky', true);
      if (isWidthDeviceMobileTablet()) {
        disableStickyElement();
      } else {
        disableStickyElement();
      }
    }
  });
};
